module.exports = __webpack_public_path__ + "img/J11134.8bb5f161.png";